import { ImageInfo } from "./communication/PlatformActions";

// application settings

export class NativeCapabilities {
  public canReserveNewTrackingId: boolean = false; // true if the `reserveNewTrackingId` command is supported, false otherwise
  public canChooseAccount: boolean = false; // true if the `chooseAccount` command is supported, false otherwise
}

export class ClientCapabilities {
  public canDisplayTypedMarkdown: boolean = true; // true if "raw" markdown is supported for display, false otherwise
  public expRichEditor: boolean = true; // true for rich text (markdown) editor, false otherwise; always true since 2019-03-25, after A/B experiment ended
  public rawTextSupport: boolean = true; // true if raw, unescaped text is supported
  public expFlights: string = ""; // experiment flights string to pass to telemetry to ensure good scorecard for Report Problem. Has all flights for VS and Report Problem
}

export type NullableString = string | null;

export class AssemblyFileNames {
  public assemblyName: string | null; // e.g. "Microsoft.PythonTools"
  public filePaths: NullableString[] | null = []; // e.g. ["C:\\Users\\nikolami\\AppData\\Local\\Temp\\PythonToolsDiagnostics_20190716162519.log"]
}

export class Settings {
  /** true to use web recording, false to use psr.exe. Set by newer version feedback.exe to true.
   * Will always be true after some point (2025-06-xx) because we swtch to web recording only.
   * Note: default value must be false, since older feedback.exe will not set the value and setting by default 
   * to true will break older feedback.exe versions that do not support web recording.
   */
  public useWebRecording: boolean = false;

  public template: any = {};
  public collectDiagnostics: string = "collectdiagnostics";
  public launcherPath: string = "";
  public productInstallPath: string = "";
  public feedbackCollector: string = "Common7\\IDE\\FeedbackCollector.exe";
  public productExePath: string = "";
  public currentProcessId: number = 0;
  // Additional Process Ids for which to collect diagnostics information
  public additionalProcessIds: number[] = [];

  public loadStartMsec: number;
  public loadDurationMsec: number;

  // isinternal: 'false' means maybe Internal & 'true' means definitely Internal
  public isInternal: boolean = false;
  public screenshotThumb: ImageInfo | null = null;
  public screenshotPath: string | null = null;
  public screenshotThumbPath: string | null = null;

  public feedbackSessionId: string = "Default";
  // We're using the dataOptIn in main.ts. If anything changes in settings.ts, please change it in main.ts as well
  public dataOptIn: boolean = false;
  public filesToUpload: string[] = []; // list of additional files to upload, if any
  public filesToUploadPerAssembly: AssemblyFileNames[] | null = []; // list of additional files to upload, if any

  // true to disable recording, false to enable recording (default)
  // set to true for clients where recording doesn't make sense, e.g. VS Installer
  public isRecordingDisabled: boolean = false;

  public initialSearchText: string | null = null; // text showing the first time a customer starts the feedback console
  public initialReproText: string | null = null; // text showing the first time a customer opens the "create new issue" dialog
  public reproTextTemplate: string | null = null; // text showing either every time (if initialReproText is null) or every time but the first (if initialReproText is not null)

  public serviceHubPath: string | undefined; // path to service hub configuration file, used to get refresh token from correct VS version (2017 vs 2019 vs Installer)
  public capabilities: ClientCapabilities = new ClientCapabilities(); // sent to server to seamlessly support back- and forward-compat between clients
  public nativeCapabilities: NativeCapabilities = new NativeCapabilities(); // sent from feedback.exe to DevCom2 website - contains feedback.exe's capabilities
}
